import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    InsuranceTypeDto,
    CreateInsuranceTypeDto,
    UpdateInsuranceTypeDto,
} from '../../../core/data/new-dtos/insurance-type.dtos';
@Injectable({
    providedIn: 'root',
})
export class InsuranceTypesService {
    private baseUrl = 'InsuranceTypes';

    constructor(private http: HttpClient) { }

    getAll(
        bankId?: number,
        sortBy: string = 'priority',
        sortDirection: 'asc' | 'desc' = 'asc',
    ): Observable<InsuranceTypeDto[]> {
        const params: any = { sortBy, sortDirection };
        if (bankId !== undefined && bankId !== null) {
            params.bankId = bankId;
        }
        return this.http.get<InsuranceTypeDto[]>(this.baseUrl, { params });
    }

    getById(id: number): Observable<InsuranceTypeDto> {
        return this.http.get<InsuranceTypeDto>(`${this.baseUrl}/${id}`);
    }

    create(dto: CreateInsuranceTypeDto): Observable<number> {
        return this.http.post<number>(this.baseUrl, dto);
    }

    update(id: number, dto: UpdateInsuranceTypeDto): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/${id}`, dto);
    }

    /** A bank's own choice about offering a Colonial product (global admins). */
    setBankVisibility(id: number, visible: boolean): Observable<void> {
        return this.http.patch<void>(`${this.baseUrl}/${id}/bank-visibility`, { visible });
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    reorder(orderedIds: number[]): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/reorder`, { orderedIds });
    }
}
